/**
 * Ismetlodo emlekeztetok: mikor jon a kovetkezo alkalom.
 *
 * ─── Miert nem eleg egy "+1 nap"? ───────────────────────────────────────────
 *
 * Mert a "minden reggel 9-kor" nem 24 orankent van. Az oraatallitaskor az egyik
 * nap 23, a masik 25 orabol all - egy naiv millimasodperc-osszeadas utan a
 * felhasznalo tavasszal 8-kor, osszel 10-kor kapna az emlekeztetot, es soha
 * tobbe nem allna vissza. Az ismetlodes FALIORA szerint ertendo, nem
 * idotartam szerint.
 *
 * Ezert minden szamitas ugyanazt a ket lepest jarja be: az UTC-idopontot
 * atvaltjuk a kero zonajanak faliorajara, ott lepunk egy napot/hetet/honapot,
 * majd a kapott faliorat visszavaltjuk UTC-re. A ket iranyt az `Intl` adja -
 * nem kell hozza kulso konyvtar, es az IANA-adatbazis a futtatokornyezettel
 * egyutt frissul.
 *
 * ─── A hetnapok szamozasa ───────────────────────────────────────────────────
 *
 * 0 = vasarnap, ahogy a munkaido `workCustomDays` mezojenel is. Ket egymas
 * melletti, egyforma jelentesu mezo ne szamozzon ketfelekeppen.
 */
/** Ilyen ismetlodesek allithatok. A `none` az egyszeri emlekezteto. */
export const reminderRepeatKinds = ['none', 'daily', 'weekly', 'monthly'];
const formatters = new Map();
function formatterFor(timeZone) {
    const kesz = formatters.get(timeZone);
    if (kesz)
        return kesz;
    const uj = new Intl.DateTimeFormat('en-US', {
        timeZone,
        /*
          `hourCycle`, es NEM `hour12: false`.
    
          Az utobbi mellett egyes futtatokornyezetek ejfelt `24`-kent irjak - a
          nap sorszama viszont ilyenkor a REGI nape marad, tehat a ketto egyutt
          egy teljes napot csuszna. A `h23` mindig 0-23 kozott ad orat.
        */
        hourCycle: 'h23',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
    formatters.set(timeZone, uj);
    return uj;
}
/** Mit mutat az ora az adott zonaban ebben a pillanatban. */
export function wallClockIn(date, timeZone) {
    const parts = formatterFor(timeZone).formatToParts(date);
    const ertek = (type) => Number(parts.find((part) => part.type === type)?.value ?? '0');
    return {
        year: ertek('year'),
        month: ertek('month'),
        day: ertek('day'),
        hour: ertek('hour'),
        minute: ertek('minute'),
    };
}
/** A zona eltolasa ebben a pillanatban, millimasodpercben. */
function offsetMs(date, timeZone) {
    const wall = wallClockIn(date, timeZone);
    const parts = formatterFor(timeZone).formatToParts(date);
    const second = Number(parts.find((part) => part.type === 'second')?.value ?? '0');
    const mintha = Date.UTC(wall.year, wall.month - 1, wall.day, wall.hour, wall.minute, second);
    // Az `Intl` masodperc-pontossagu; a maradek ezredet a forrasbol hozzuk vissza.
    return mintha - (date.getTime() - date.getMilliseconds());
}
/**
 * Faliorabol UTC.
 *
 * KET korben szamol. Az elso tipp meg a REGI eltolassal keszul, es az
 * oraatallitas napjan melle nyulna egy oraval; a masodik kor a mar helyes
 * pillanat eltolasaval javit. Ennel tobb kor nem hoz ujat.
 *
 * A nem letezo faliora (tavasszal a kimarado ora) a kovetkezo letezo
 * pillanatra esik - ez a szokasos, es a helyes viselkedes: az emlekezteto
 * inkabb szoljon egy oraval kesobb, mint hogy elmaradjon.
 */
export function fromWallClock(wall, timeZone) {
    const naiv = Date.UTC(wall.year, wall.month - 1, wall.day, wall.hour, wall.minute);
    let ido = naiv - offsetMs(new Date(naiv), timeZone);
    ido = naiv - offsetMs(new Date(ido), timeZone);
    return new Date(ido);
}
/** A honap hossza - a `monthly` ismetlodes ehhez igazodik. */
function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month, 0)).getUTCDate();
}
/** Egy faliora-datum hetnapja. 0 = vasarnap. */
function weekdayOf(wall) {
    return new Date(Date.UTC(wall.year, wall.month - 1, wall.day)).getUTCDay();
}
/** Naptari nap hozzaadasa a faliora-datumhoz - az idopont valtozatlan. */
function plusDays(wall, days) {
    const eltolva = new Date(Date.UTC(wall.year, wall.month - 1, wall.day + days));
    return {
        year: eltolva.getUTCFullYear(),
        month: eltolva.getUTCMonth() + 1,
        day: eltolva.getUTCDate(),
        hour: wall.hour,
        minute: wall.minute,
    };
}
/**
 * A KOVETKEZO alkalom - vagy `null`, ha nincs tobb.
 *
 * A `previous` a most lejart alkalom; a valasz mindig szigoruan utana van.
 * `null` akkor jon vissza, ha nincs ismetlodes, vagy ha a sorozat a
 * `rule.until` hataron tullepne.
 */
export function nextOccurrence(previous, rule) {
    if (rule.kind === 'none')
        return null;
    const wall = wallClockIn(previous, rule.timeZone);
    let kovetkezo = null;
    if (rule.kind === 'daily') {
        kovetkezo = plusDays(wall, 1);
    }
    else if (rule.kind === 'weekly') {
        /*
          URES napokkal a kezdonap napjan ismetlodik.
    
          Igy a "hetente" kapcsolo onmagaban is ertelmes: aki keddre allitotta be,
          annak keddenkent szol. Egy ures lista miatt nem hallgatunk el.
        */
        const napok = new Set(rule.days.length > 0 ? rule.days : [weekdayOf(wall)]);
        for (let elore = 1; elore <= 7; elore += 1) {
            const jelolt = plusDays(wall, elore);
            if (napok.has(weekdayOf(jelolt))) {
                kovetkezo = jelolt;
                break;
            }
        }
    }
    else {
        /*
          A ROVIDEBB honap nem ejti ki az alkalmat, es nem is csusztat.
    
          A 31-ere kert emlekezteto februarban a honap utolso napjan szol -
          marciusban viszont ujra 31-en, mert a nap sorszamat a SOROZAT ELSO
          alkalmabol vesszuk, nem a legutobb megvagottbol.
        */
        const ev = wall.month === 12 ? wall.year + 1 : wall.year;
        const honap = wall.month === 12 ? 1 : wall.month + 1;
        const eredetiNap = rule.anchor
            ? wallClockIn(new Date(rule.anchor), rule.timeZone).day
            : wall.day;
        kovetkezo = {
            year: ev,
            month: honap,
            day: Math.min(eredetiNap, daysInMonth(ev, honap)),
            hour: wall.hour,
            minute: wall.minute,
        };
    }
    if (!kovetkezo)
        return null;
    const idopont = fromWallClock(kovetkezo, rule.timeZone);
    if (rule.until && idopont.getTime() > new Date(rule.until).getTime())
        return null;
    return idopont;
}
/**
 * A sorozat ELSO alkalma.
 *
 * Heti ismetlodesnel a kezdes napja nem feltetlenul a kivalasztott napok
 * egyike: aki kedden allit be egy "hétfő, péntek" sorozatot, az nem varja,
 * hogy kedden is kimenjen. Ilyenkor az elso alkalom a kezdes utani elso
 * kivalasztott nap, ugyanabban az oraban. `null`, ha a "meddig" ezt kizarja.
 */
export function firstOccurrence(start, rule) {
    if (rule.kind !== 'weekly' || rule.days.length === 0)
        return start;
    if (rule.days.includes(weekdayOf(wallClockIn(start, rule.timeZone))))
        return start;
    return nextOccurrence(start, rule);
}
const NAPNEVEK = ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'];
/**
 * Az ismetlodes emberi olvasatra.
 *
 * A felulet ezt irja a beallitas ala: az az egy mondat donti el, hogy a
 * felhasznalo latja-e, mire szamitson. Az idopont a kezdo alkalombol jon.
 */
export function describeRepeat(first, rule) {
    if (rule.kind === 'none')
        return 'Egyszeri';
    const wall = wallClockIn(first, rule.timeZone);
    const ido = `${wall.hour}:${String(wall.minute).padStart(2, '0')}`;
    if (rule.kind === 'daily')
        return `Minden nap ${ido}`;
    if (rule.kind === 'monthly') {
        const nap = rule.anchor ? wallClockIn(new Date(rule.anchor), rule.timeZone).day : wall.day;
        return `Minden hónap ${nap}-én ${ido}`;
    }
    const napok = rule.days.length > 0 ? [...rule.days].sort() : [weekdayOf(wall)];
    // Hetfotol vasarnapig olvassuk, ahogy a naptar is all.
    const sorrend = napok.map((nap) => (nap === 0 ? 7 : nap)).sort((a, b) => a - b);
    const nevek = sorrend.map((nap) => NAPNEVEK[nap === 7 ? 0 : nap]);
    return `Minden ${nevek.join(', ')} ${ido}`;
}
//# sourceMappingURL=recurrence.js.map